const theme = {
    colors: {
        black: "#191A1C",
        light_black: "#151718",
        grey: "#8C8C8D",
        dark_grey: "#6A6A6B",
        light_grey: "#F2F2F2",
        light_grey2: "#E9ECEF",
        white: "#FFFFFF",
        dark_white: "#F5F5F5",
        red: "#E63946",
        pink: "#D9B6A9",
    },

    fz: {
        XXXL: "4.2rem",
        XXL: "3.6rem",
        XL: "3.2rem",
        L: "3rem",
        M: "2.2rem",
        S: "2rem",
        XS: "1.6rem",
        XXS: "1.4rem",
        XXXS: "1.2rem",
    },
    ff: {
        Montserrat: "Montserrat,Ubuntu,Arial,sans-serif",
        Ubuntu: "Ubuntu,Montserrat,Arial,sans-serif",
        SourcePro: "'Source Serif Pro',serif",
        Tomica: "Tomica,Montserrat,Ubuntu,Arial,sans-serif",
        Cormorant: "'Cormorant Infant',serif",
    },
    fw: {
        light: "300",
        regular: "400",
        semiBold: "600",
        bold: "700",
        black: "900",
    },
};

export default theme;
